import { Component, OnInit } from '@angular/core';
import { BaseDialog } from '../../../base-dialog';
import { MatDialogRef } from '@angular/material';

@Component({
  selector: 'mandae-integration-setup-introduction-dialog',
  templateUrl: './integration-setup-introduction-dialog.component.html',
  styleUrls: ['./integration-setup-introduction-dialog.component.scss']
})
export class IntegrationSetupIntroductionDialogComponent extends BaseDialog<IntegrationSetupIntroductionDialogComponent> implements OnInit {

  constructor(dialogRef: MatDialogRef<IntegrationSetupIntroductionDialogComponent>) {
    super(dialogRef);
  }

  ngOnInit() {}

  confirm() {
    this.dialogRef.close({ next: true });
  }

}
